import type { TableAction, TableColumn } from '../Components/PRMTable/PRMTableType';

export const columns: TableColumn[] = [
  { key: 'companyName', label: 'Company Name' },
  { key: 'businessModel', label: 'Business Model' },
  {
    key: 'hmGroupBrand',
    label: 'H&M Group Brand',
    width: '280px',
    chips: [
      { field: 'activeHMGroupBrand', status: 'active' },
      { field: 'inactiveHMGroupBrand', status: 'inactive' },
    ],
  },
  { key: 'category', label: 'Category' },
  { key: 'status', label: 'Status', width: '170px' },
  { key: 'confirmedBrands', label: 'Brands', width: '280px', showMore: { maxVisibleItems: 3 } },
];

export const accountActions: TableAction[] = [
  {
    label: 'Edit',
    icon: 'edit-write',
    onClick: () => {},
  },
];
